// import logo from './logo.svg';
import './App.css';
// import LanguageChooser from './Components/LanguageChooser/LanguageChooser';
import { appContext } from './Context/appProvider';
import {
    Outlet
  } from "react-router-dom";
import Layout from './Layout';
import { useContext } from 'react';
import Signin from './Pages/Signin/Signin';
import Notification from './Components/Notification/Notification';


function Root() {
    const { token, notification, setNotification } = useContext(appContext)
    return token ? (
        <Layout>
            {notification.visible && <Notification setNotification={setNotification} type={notification.type} message={notification.message} /> }
            <Outlet />
        </Layout>
    ) : (
        <Signin />
    )
}

export default Root;